import { CUSTOMERS_QUERY } from 'constants/customerQueries';
import axios from 'services/axios';

export function getCustomers() {
  return axios.post('/graphql', {
    query: CUSTOMERS_QUERY,
  });
}
